// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import { createGetOpts, config } from '@src/utils/sliders';

import type {
  DepthSearchFilterType,
  DepthSearchExtentType
} from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as DepthContent from '@components/popups/content/Depth';

const optionsFunc = (values, extents, step, margin) => {
  // hide slider via ErrorBoundary
  if (extents[0] === extents[1]) throw new Error("min and max can't be equal");

  return {
    start: values,
    range: {
      min: extents[0],
      max: extents[1]
    },
    step: step,
    margin: margin,
    connect: [false, true, false]
  };
};

type PropsType = {
  onSliderUpdate: OnSliderUpdateType,
  value: DepthSearchFilterType | void,
  extent: DepthSearchExtentType,
  disableTabIndex?: boolean
};

const Popup = () => <QuestionMarkPopup initialContent={DepthContent} />;

export default class DepthSlider extends React.Component<PropsType> {
  render() {
    const { value, extent, onSliderUpdate } = this.props;
    const getOpts = createGetOpts(extent, optionsFunc, config.depth);

    return (
      <GenericSlider
        title={'Depth'}
        getOpts={getOpts}
        value={value || extent}
        userValue={value}
        extent={extent}
        onSliderUpdate={values =>
          onSliderUpdate('UPDATE_DEPTH_PERCENT', values.map(Number))
        }
        Popup={Popup}
        formatter={num => `${num} %`}
        inputWidth={'60px'}
        inputStep={config.depth.stepSize}
        inputStepMargin={config.depth.margin}
        disableTabIndex={this.props.disableTabIndex}
        inputs
      />
    );
  }
}
